import React from 'react';
import { ShopResultListHeaderProps } from 'models/ShopResultListHeaderProps';
import { ShopResultListHeader as ShopResultListHeaderStyled } from './ShopResultListHeader.styles';
import CertificationFilter from './CertificationFilter/CertificationFilter';
import CategoryOpener from './CategoryOpener/CategoryOpener';
import Sorting from './Sorting/Sorting';
import { FormattedMessage, useIntl } from 'react-intl';
import { Heading } from '@trustedshops/tps-seo-shared-frontend-react-components';
import { pluralize } from 'helpers/pluralize';

const ShopResultListHeader = ({
  category,
  keyword,
  numberResults,
  activeFilters,
  onParameterChange,
  setModalVisible
}: ShopResultListHeaderProps) => {
  const { formatMessage, locale } = useIntl();
  const query = activeFilters.q || keyword;
  const headline = activeFilters.account ? (
    <Heading as="h2" $lookAlike="h3">
      {formatMessage(
        { id: pluralize('RESULTS.HEADLINE.ACCOUNT', numberResults, locale) },
        { count: numberResults }
      )}
    </Heading>
  ) : (
    <Heading as="h2" $lookAlike="h3">
      {formatMessage({ id: 'RESULTS_TEXT' }, { count: numberResults })}
      <span className="for-number-results-text">
        &nbsp;
        {formatMessage({ id: 'RESULTS.HEADLINE.FOR_NUMBER_RESULTS_TEXT' })}
      </span>
      {query && (
        <span className="for-query-results-text">
          &nbsp;
          {formatMessage(
            { id: 'RESULTS.HEADLINE.FOR_QUERY_RESULTS_TEXT' },
            { q: <strong>{query}</strong> }
          )}
        </span>
      )}
      {category && !query && (
        <div className="for-query-text">
          <FormattedMessage
            id="RESULTS.HEADLINE.CATEGORY"
            values={{ category }}
          />
        </div>
      )}
      {query && (
        <div className="for-query-text">
          <FormattedMessage
            id="RESULTS.HEADLINE.FOR_QUERY_RESULTS_TEXT.MOBILE"
            values={{ q: query }}
          />
        </div>
      )}
    </Heading>
  );

  return (
    <ShopResultListHeaderStyled>
      {headline}
      <hr />
      <div className="filters-sorting">
        <CertificationFilter
          hasValidCertificate={activeFilters.hasValidCertificate}
          activeFilters={activeFilters}
          onParameterChange={onParameterChange}
        />
        <hr />
        <CategoryOpener setModalVisible={setModalVisible} category={category} />
        <Sorting
          sort={activeFilters.sort}
          setModalVisible={setModalVisible}
          activeFilters={activeFilters}
          onParameterChange={onParameterChange}
        />
      </div>
    </ShopResultListHeaderStyled>
  );
};

export default ShopResultListHeader;
